import { gEnums } from 'global/enums/globalEnums'
import { useMemo } from 'react'
import { _matchDisplayTypes } from './MatchContent'
import { MatchesDate } from './MatchesDate'

const PlayoffSchedule = ({
  levelKey,
  sectionKey,
  matches_levels,
  dateKey,
  teamKey,
  matchDisplayType = _matchDisplayTypes.scoreboard,
  matchScheduleDisplayType = gEnums.matchScheduleDisplayTypes.scoreboard,
  team_fav_keys = [],
}) => {
  const playoffMatches = useMemo(() => {
    if (_.isEmpty(matches_levels)) { return <div>No Playoff Matches</div> }
    const mls = _.sortBy(matches_levels, 'matchNumber')
    const matches_level = <MatchesDate
      levelKey={levelKey}
      sectionKey={sectionKey}
      dateKey={dateKey}
      matches={mls}
      teamKey={teamKey}
      matchDisplayType={matchDisplayType}
      matchScheduleDisplayType={matchScheduleDisplayType}
      team_fav_keys={team_fav_keys}
      forPlayoffs={true}
    />
    return matches_level
  }, [matches_levels])

  const div_section = <div className='match-date-matches ply'>
    {playoffMatches}
  </div>

  return div_section

}

export default PlayoffSchedule
